import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { font } from "../theme";

const lines: { text: string; prompt?: boolean }[] = [
  { text: "harrison@portfolio:~$ whoami", prompt: true },
  { text: "harrison_qu" },
  { text: "harrison@portfolio:~$ cat about.txt", prompt: true },
  { text: "Full-stack web & mobile developer based in NYC." },
  {
    text: "Building intuitive and unique experiences that people want to use.",
  },
  { text: "harrison@portfolio:~$ ls skills/", prompt: true },
  { text: "typescript   javascript   swift   python   sql   html   css" },
  { text: "react   react-native   zustand   tanstack   vite   storybook" },
  { text: "node   express   graphql   rest   websockets   kafka   sqs" },
  { text: "redis   postgres   typeorm   zod   docker" },
  { text: "kubernetes   argocd   playwright   jest" },
  { text: "testing-library   posthog   grafana   git" },
  { text: "harrison@portfolio:~$ echo 'thanks for stopping by :)'", prompt: true },
  { text: "thanks for stopping by :)" },
];

const Screen = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 18px 20px;
  background: #0d1117;
  color: #d6f5e3;
  font-family: ${font.mono};
  font-size: 14px;
  line-height: 1.6;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
`;

const Line = styled.div<{ $prompt?: boolean }>`
  color: ${({ $prompt }) => ($prompt ? "#7ee787" : "#d6f5e3")};
`;

const Cursor = styled.span`
  display: inline-block;
  width: 9px;
  height: 16px;
  background: #7ee787;
  margin-left: 2px;
  vertical-align: middle;
  animation: blinker 1s steps(1) infinite;
`;

const TerminalApp = () => {
  const [lineIdx, setLineIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (lineIdx >= lines.length) return;
    const current = lines[lineIdx].text;
    if (charIdx < current.length) {
      const t = setTimeout(() => setCharIdx((c) => c + 1), 22);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => {
      setLineIdx((l) => l + 1);
      setCharIdx(0);
    }, 280);
    return () => clearTimeout(t);
  }, [lineIdx, charIdx]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [lineIdx, charIdx]);

  const done = lineIdx >= lines.length;

  return (
    <Screen ref={scrollRef}>
      {lines.slice(0, lineIdx).map((line, i) => (
        <Line key={i} $prompt={line.prompt}>
          {line.text}
        </Line>
      ))}
      {!done && (
        <Line $prompt={lines[lineIdx].prompt}>
          {lines[lineIdx].text.slice(0, charIdx)}
          <Cursor />
        </Line>
      )}
      {done && (
        <Line $prompt>
          harrison@portfolio:~$ <Cursor />
        </Line>
      )}
    </Screen>
  );
};

export default TerminalApp;
